import React from "react"
import { Switch, Route, withRouter } from "react-router-dom"

import "styles/globals.scss"
import "normalize.css"
import "utils/icons"

import LandingPage from "pages/LandingPage"
import FrontEndDeveloper from "pages/JobDescriptions/FrontEndDeveloper"
import BackEndDeveloper from "pages/JobDescriptions/BackEndDeveloper"
import ProjectManager from "pages/JobDescriptions/ProjectManager"
import PadelappenBlogPost from "pages/PadelappenBlogPost"
import CaseStudies from "pages/CaseStudiesPage"
import ESENCaseStudy from "./pages/CaseStudies/ESENCaseStudy"
import MiasanoCaseStudy from "./pages/CaseStudies/MiasanoCaseStudy"
import Learn2EsportCaseStudy from "./pages/CaseStudies/Learn2EsportCaseStudy"
import { Helmet } from "react-helmet"

class App extends React.Component {
  componentDidMount = () => window.ga("create", "UA-69124129-1", "auto")

  setPageAndSendToGA = url => {
    window.ga("set", "page", url)
    window.ga("send", "pageview")
  }

  trackGoogleAnalytics = location => {
    if (window.ga) {
      this.setPageAndSendToGA(location.pathname)
    }
  }

  render() {
    this.trackGoogleAnalytics(this.props.location)
    const defaultTitle = "SAITS - Sandström & Andreasson IT Solutions AB"

    return (
      <React.Fragment>
        <Helmet
          titleTemplate={`${defaultTitle} | %s`}
          defaultTitle={defaultTitle}
        />
        <Switch>
          <Route
            path="/vacancies/front-end-developer"
            component={FrontEndDeveloper}
          />
          <Route
            path="/vacancies/back-end-developer"
            component={BackEndDeveloper}
          />
          <Route path="/vacancies/project-manager" component={ProjectManager} />
          <Route path="/blogpost/padelappen" component={PadelappenBlogPost} />
          <Route path="/case-studies" exact component={CaseStudies} />
          <Route path="/case-studies/esen" component={ESENCaseStudy} />
          <Route path="/case-studies/miasano" component={MiasanoCaseStudy} />
          <Route
            path="/case-studies/learn2esport"
            component={Learn2EsportCaseStudy}
          />
          <Route path="/" exact component={LandingPage} />
        </Switch>
      </React.Fragment>
    )
  }
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/App.jsx